import React, { useState } from 'react';
import ReactDOM from 'react-dom';

const ConfirmDialog = ({ title, message, onConfirm, onCancel }) => {
  const [confirming, setConfirming] = useState(false);

  const handleConfirm = () => {
    setConfirming(true);
    onConfirm(true);
  };

  const handleCancel = () => {
    onCancel(false);
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '2rem',
        maxWidth: '400px',
        width: '90%',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
        border: '1px solid #e9ecef'
      }}>
        <h3 style={{
          margin: '0 0 1rem 0',
          color: '#2c3e50',
          fontSize: '1.25rem',
          fontWeight: '600'
        }}>
          {title}
        </h3>
        <p style={{
          margin: '0 0 2rem 0',
          color: '#6c757d',
          lineHeight: '1.5'
        }}>
          {message}
        </p>
        <div style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={handleCancel}
            style={{
              padding: '0.75rem 1.5rem',
              borderRadius: '8px',
              border: '1px solid #6c757d',
              backgroundColor: '#6c757d',
              color: 'white',
              fontSize: '1rem',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#5a6268'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#6c757d'}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            style={{
              padding: '0.75rem 1.5rem',
              borderRadius: '8px',
              border: '1px solid #dc3545',
              backgroundColor: '#dc3545',
              color: 'white',
              fontSize: '1rem',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
            disabled={confirming}
          >
            {confirming ? 'confirming...' : 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Export a function that shows the dialog and returns a promise
export const confirmDialog = (title, message) => {
  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);

    const handleConfirm = (confirmed) => {
      cleanup();
      resolve(confirmed);
    };

    const handleCancel = (cancelled) => {
      cleanup();
      resolve(cancelled);
    };

    const cleanup = () => {
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
    };

    ReactDOM.render(
      <ConfirmDialog
        title={title}
        message={message}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />,
      container
    );
  });
};

export default ConfirmDialog;
